import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayoutV2.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
// Profile
import UserProfile from "@/pages/Dashboard/Examples/UserProfile.vue";

// User Management
import ListUserPage from "@/pages/Dashboard/Examples/UserManagement/ListUserPage.vue";

// Pages
// import RtlSupport from "@/pages/Dashboard/Pages/RtlSupport.vue";
import Login from "@/pages/Dashboard/Pages/Login.vue";
// import Register from "@/pages/Dashboard/Pages/Register.vue";
import RetouchersOrder from "@/pages/Dashboard/Pages/RetouchersOrder.vue";
import RetouchersOrderFuncBased from "@/pages/Dashboard/Pages/RetouchersOrderFuncBased.vue";
import RetouchersOrderFuncBasedNewProstoy from "@/pages/Dashboard/Pages/RetouchersOrderFuncBasedNewProstoy.vue";
import RetouchersOrderFuncBasedNewProstoyWrapper from "@/pages/Dashboard/Pages/RetouchersOrderFuncBasedNewProstoyWrapper.vue";
import Users from "@/pages/Dashboard/Pages/Users.vue";
import TranslatePageAdmin from "@/pages/Dashboard/Pages/TranslatePageAdmin.vue";
import StartBonusClient from "@/pages/Dashboard/Pages/StartBonusClient.vue";
import AdminConfigs from "@/pages/Dashboard/Pages/AdminConfigs";
// Components pages
// import Icons from "@/pages/Dashboard/Components/Icons.vue";
// import Typography from "@/pages/Dashboard/Components/Typography.vue";
// TableList pages
// import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";
import ScheduleTable from "@/pages/Dashboard/Tables/ScheduleTable.vue";
import ScheduleTable2 from "@/pages/Dashboard/Tables/ScheduleTable2.vue";
import ScheduleTable3 from "@/pages/Dashboard/Tables/ScheduleTable3.vue";
import ScheduleTable4 from "@/pages/Dashboard/Tables/ScheduleTable4.vue";
import ScheduleTablePro from "@/pages/Dashboard/Tables/ScheduleTablePro.vue";
import SalaryTable from "@/pages/Dashboard/Tables/SalaryTable.vue";
import SkillsTable from "@/pages/Dashboard/Tables/SkillsTable.vue";
import ProRetouchersOrderCheck from "@/pages/Dashboard/Pages/ProRetouchersOrderCheck";
import ProRetouchersOrderEducationCheck from "@/pages/Dashboard/Pages/ProRetouchersOrderEducationCheck";
import ProRetouchersOrderEducationHistory from "@/pages/Dashboard/Pages/ProRetouchersOrderEducationHistory";
import ProRetouchersProgressReport from "@/pages/Dashboard/Pages/ProRetouchersProgressReport";
import SeniorRetouchersOrderCheck from "@/pages/Dashboard/Pages/SeniorRetouchersOrderCheck";
import FunctionsElements from "@/pages/Dashboard/Pages/FunctionsElements";
import FunctionsDescription from "@/pages/Dashboard/Pages/FunctionsDescription";
import AcquaintanceWithTheAccount from "@/pages/Dashboard/Pages/AcquaintanceWithTheAccount";
import FunctionsListEdit from "@/pages/Dashboard/Pages/FunctionsListEdit";
import AdminOrdersHistory from "@/pages/Dashboard/Pages/AdminOrdersHistory";
import AdminProgressReport from "@/pages/Dashboard/Pages/AdminProgressReport";
import OrderSimpleView from "@/pages/Dashboard/Pages/OrderSimpleView";
import AdminReports from "@/pages/Dashboard/Pages/AdminReports";
import ClientAnalytics from "@/pages/Dashboard/Pages/ClientAnalytics";

// Maps pages
// import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";
//import middleware
import auth from "@/middleware/auth";
import guest from "@/middleware/guest";
import is_retoucher from "@/middleware/is_retoucher";
import is_pro_retoucher from "@/middleware/is_pro_retoucher";
import is_pro_retoucher_admin_mini_admin_test_admin_senior_retoucher from "@/middleware/is_pro_retoucher_admin_mini_admin_test_admin_senior_retoucher";
import is_education_pro_retoucher from "@/middleware/is_education_pro_retoucher";
import is_senior_retoucher from "@/middleware/is_senior_retoucher";
import is_junior_retoucher from "@/middleware/is_junior_retoucher";
import is_test_retoucher from "@/middleware/is_test_retoucher";
import is_admin from "@/middleware/is_admin";
import is_admins from "@/middleware/is_admins";
import is_admin_and_senior from "@/middleware/is_admin_and_senior";
import is_admin_and_senior_for_salary from "@/middleware/is_admin_and_senior_for_salary";
import is_admin_and_tester from "@/middleware/is_admin_and_tester";
import is_admins_and_senior from "@/middleware/is_admins_and_senior";
import is_admins_and_senior_and_test_admin from "@/middleware/is_admins_and_senior_and_test_admin";
import isnt_pro_retoucher from "@/middleware/isnt_pro_retoucher";
import is_retoucher_and_junior_retoucher from "@/middleware/is_retoucher_and_junior_retoucher";
import OrderView from "../pages/Dashboard/Pages/OrderView";
import RetouchersProgressReport from "../pages/Dashboard/Pages/RetouchersProgressReport";
import SalaryTable2 from "../pages/Dashboard/Tables/SalaryTable2.vue";
import SalaryRetoucherTable from "../pages/Dashboard/Tables/SalaryRetoucherTable.vue";
import SalaryProRetoucherTable from "../pages/Dashboard/Tables/SalaryProRetoucherTable.vue";


let componentsMenu = {
    path: "/components",
    component: DashboardLayout,
    redirect: "/user-profile",
    name: "Components",
    children: [
        {
            path: "users",
            name: "Users",
            components: {default: Users},
            meta: {middleware: [auth, is_admins]}
        },
        {
            path: "scheduletable",
            name: "ScheduleTable",
            components: {default: ScheduleTable},
            meta: {middleware: [auth, isnt_pro_retoucher]}
        },
        {
            path: "scheduletable2",
            name: "ScheduleTable2",
            components: {default: ScheduleTable2},
            meta: {middleware: auth}
        },
        {
            path: "scheduletable3",
            name: "ScheduleTable3",
            components: {default: ScheduleTable3},
            meta: {middleware: auth}
        },
        {
            path: "scheduletable4",
            name: "ScheduleTable4",
            components: {default: ScheduleTable4},
            meta: {middleware: auth}
        },
        {
            path: "scheduletable-pro",
            name: "ScheduleTable-pro",
            components: {default: ScheduleTablePro},
            meta: {middleware: auth}
        },
        {
            path: "salary2",
            name: "Salary2",
            components: {default: SalaryTable2},
            meta: {middleware: [auth, is_admin_and_senior_for_salary]}
        },
        {
            path: "salary",
            name: "Salary",
            components: {default: SalaryTable},
            meta: {middleware: [auth, is_admin]}
        },
        {
            path: "skills",
            name: "Skills",
            components: {default: SkillsTable},
            meta: {middleware: auth}
        },
        {
            path: "translate",
            name: "translate",
            components: {default: TranslatePageAdmin},
            meta: {middleware: [auth, is_admin]}
        },
        {
            path: "startbonus",
            name: "startbonus",
            components: {default: StartBonusClient},
            meta: {middleware: [auth, is_admin]}
        },
    ]
};

let myMenuItems = {
    path: "/adminSettings",
    component: DashboardLayout,
    name: "Settings",
    children: [
        {
            path: "appConfigs",
            name: "appConfigs",
            components: {default: AdminConfigs},
            meta: {middleware: [auth, is_admin]}
        }
    ]
};

let newMvpItems = {
    path: "/new_mvp",
    component: DashboardLayout,
    name: "NewMvp",
    children: [
        {
            path: "orderCheck",
            name: "ProRetouchersOrderCheck",
            components: {default: ProRetouchersOrderCheck},
            meta: {middleware: [auth, is_pro_retoucher]}
        },
        {
            path: "orderCheckEducation",
            name: "ProRetouchersOrderEducationCheck",
            components: {default: ProRetouchersOrderEducationCheck},
            meta: {middleware: [auth, is_pro_retoucher, is_education_pro_retoucher]}
        },
        {
            path: "orderEducationHistory",
            name: "ProRetouchersOrderEducationHistory",
            components: {default: ProRetouchersOrderEducationHistory},
            meta: {middleware: [auth, is_pro_retoucher, is_education_pro_retoucher]}
        },
        {
            path: "orderView",
            name: "OrderView",
            components: {default: OrderView},
            meta: {middleware: [auth, is_pro_retoucher]}
        },
        {
            path: "proRetoucherProgressReport",
            name: "ProRetouchersProgressReport",
            components: {default: ProRetouchersProgressReport},
            meta: {middleware: [auth, is_pro_retoucher]}
        },
        {
            path: "retoucherProgressReport",
            name: "RetouchersProgressReport",
            components: {default: RetouchersProgressReport},
            meta: {middleware: [auth, is_retoucher_and_junior_retoucher]}
        },
        {
            path: "seniorRetoucherOrderCheck",
            name: "SeniorRetouchersOrderCheck",
            components: {default: SeniorRetouchersOrderCheck},
            meta: {middleware: [auth, is_senior_retoucher]}
        },

        {
            path: "order",
            name: "RetouchersOrder",
            components: {default: RetouchersOrder},
            meta: {middleware: [auth, is_retoucher]}
        },

        {
            path: "order-func-based",
            name: "RetouchersOrderFuncBased",
            components: {default: RetouchersOrderFuncBased},
            meta: {middleware: [auth, is_retoucher]}
        },

        // {
        //     path: "order-new-idle-time",
        //     name: "RetouchersOrderFuncBasedNewProstoy",
        //     components: {default: RetouchersOrderFuncBasedNewProstoy},
        //     meta: {middleware: [auth, is_retoucher]}
        // },

        {
            //path: "order-new-idle-time-wrapper",
            path: "order-new-idle-time",
            name: "RetouchersOrderFuncBasedNewProstoyWrapper",
            components: {default: RetouchersOrderFuncBasedNewProstoyWrapper},
            meta: {middleware: [auth, is_retoucher]}
        },

        // {
        //     path: "order-new-prostoy",
        //     name: "RetouchersOrderFuncBasedNewProstoy",
        //     components: {default: RetouchersOrderFuncBasedNewProstoy},
        //     meta: {middleware: [auth, is_retoucher]}
        // },

        {
            path: "juniorRetoucherOrder",
            name: "RetouchersOrder",
            components: {default: RetouchersOrder},
            //components: {default: RetouchersOrderFuncBasedNewProstoyWrapper},
            meta: {middleware: [auth, is_junior_retoucher]}
        },
        {
            path: "order_for_test_retoucher",
            name: "RetouchersOrder",
            components: {default: RetouchersOrder},
            meta: {middleware: [auth, is_test_retoucher]}
        },
        {
            path: "orderCheck_for_test_retoucher",
            name: "ProRetouchersOrderCheck",
            components: {default: ProRetouchersOrderCheck},
            meta: {middleware: [auth, is_test_retoucher]}
        },
        {
            path: "seniorRetoucherOrderCheck_for_test_retoucher",
            name: "SeniorRetouchersOrderCheck",
            components: {default: SeniorRetouchersOrderCheck},
            meta: {middleware: [auth, is_test_retoucher]}
        },
        {
            path: "functions_elements",
            name: "FunctionsElements",
            components: {default: FunctionsElements},
            meta: {middleware: [auth, is_admin]}
        },
        {
            path: "functions_description",
            name: "FunctionsDescription",
            components: {default: FunctionsDescription},
            meta: {middleware: [auth]}
        },
        {
            path: "acquaintance_with_the_account",
            name: "acquaintanceWithTheAccount",
            components: {default: AcquaintanceWithTheAccount},
            meta: {middleware: [auth, is_retoucher_and_junior_retoucher]}
        },
        {
            path: "admin_orders_history",
            name: "AdminOrdersHistory",
            components: {default: AdminOrdersHistory},
            meta: {middleware: [auth, is_admins_and_senior_and_test_admin]}
        },
        {
            path: "admin_progress_report",
            name: "AdminProgressReport",
            components: {default: AdminProgressReport},
            meta: {middleware: [auth, is_admins_and_senior]}
        },
        {
            path: "retoucherSalary",
            name: "RetoucherSalary",
            components: {default: SalaryRetoucherTable},
            meta: {middleware: [auth, is_retoucher_and_junior_retoucher]}
        },
        {
            path: "proretoucherSalary",
            name: "ProRetoucherSalary",
            components: {default: SalaryProRetoucherTable},
            meta: {middleware: [auth, is_pro_retoucher]}
        },
        {
            path: "admin-reports",
            name: "AdminReports",
            components: {default: AdminReports},
            meta: {middleware: [auth, is_admins_and_senior]}
        },
        {
            path: "client-analytics",
            name: "ClientAnalytics",
            components: {default: ClientAnalytics},
            meta: {middleware: [auth, is_admin_and_tester]}
        },

    ]
};

let examplesMenu = {
    path: "/examples",
    component: DashboardLayout,
    name: "Examples",
    children: [
        {
            path: "user-profile",
            name: "User Profile",
            components: {default: UserProfile},
            meta: {middleware: auth}
        },
        {
            path: "user-management/list-users",
            name: "List Users",
            components: {default: ListUserPage},
            meta: {middleware: auth}
        }
    ]
};

let authPages = {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    children: [
        {
            path: "/login",
            name: "Login",
            component: Login,
            meta: {middleware: guest}
        },
        // {
        //     path: "/register",
        //     name: "Register",
        //     component: Register,
        //     meta: {middleware: guest}
        // }
    ]
};

let otherPages = {
    path: "/",
    component: DashboardLayout,
    name: "otherPages",
    meta: {middleware: auth},
    children: [
        {
            path: "/order/*",
            name: "OrderSimpleView",
            component: OrderSimpleView,
            meta: {middleware: auth}
        }
    ]
};

const routes = [
    {
        path: "/",
        redirect: "/user-profile",
        name: "Home"
    },
    {
        path: "/",
        component: DashboardLayout,
        meta: {middleware: auth},
        children: [
            {
                path: "user-profile",
                name: "User Profile",
                components: {default: UserProfile},
                meta: {middleware: auth}
            }
        ]
    },
    newMvpItems,
    componentsMenu,
    examplesMenu,
    authPages,
    myMenuItems,
    otherPages
];

export default routes;
